export default {
    mounted: function () {
        this.load()
    },
    methods: {
        load: function () {
            this.$nextTick(function(){
                this.$store.dispatch('cart/hydrate')
            });
        }
    }
}
